import { motion } from "framer-motion";
import { KEY_DATES } from "@/lib/constants";
import { Countdown } from "@/components/Countdown";
import { useI18n } from "@/i18n/I18nContext";

export const Timeline = () => {
  const { t } = useI18n();
  const events = [
    { date: t("timeline.e1d"), title: t("timeline.e1t"), text: t("timeline.e1x"), countdown: KEY_DATES.preinscription },
    { date: t("timeline.e2d"), title: t("timeline.e2t"), text: t("timeline.e2x"), countdown: KEY_DATES.officialisation },
    { date: t("timeline.e3d"), title: t("timeline.e3t"), text: t("timeline.e3x"), countdown: null },
  ];

  return (
    <section id="calendrier" data-testid="timeline-section" className="relative py-28 md:py-36 px-6 lg:px-10">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-20">
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-theatre-gold mb-5">{t("timeline.eyebrow")}</p>
          <h2 className="font-serif text-3xl md:text-5xl text-white">{t("timeline.title")}</h2>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-theatre-gold/50 to-transparent md:-translate-x-1/2" aria-hidden="true" />

          {events.map((e, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7 }}
              data-testid={`timeline-event-${i}`}
              className={`relative mb-16 pl-14 md:pl-0 md:w-1/2 ${i % 2 === 0 ? "md:pr-14 md:text-right" : "md:ml-auto md:pl-14"}`}
            >
              <span
                className={`absolute top-2 left-2.5 md:left-auto w-4 h-4 rounded-full bg-theatre-red shadow-[0_0_16px_4px_rgba(155,17,30,0.6)] ${
                  i % 2 === 0 ? "md:-right-2" : "md:-left-2"
                }`}
                aria-hidden="true"
              />
              <p className="font-mono text-xs tracking-[0.25em] uppercase text-theatre-gold">{e.date}</p>
              <h3 className="mt-3 font-serif text-2xl text-white">{e.title}</h3>
              <p className="mt-3 text-sm text-neutral-400 leading-relaxed">{e.text}</p>
              {e.countdown && (
                <div className={`mt-6 flex ${i % 2 === 0 ? "md:justify-end" : "justify-start"}`}>
                  <div className="scale-[0.65] origin-left md:origin-right">
                    <Countdown target={e.countdown} testId={`timeline-countdown-${i}`} />
                  </div>
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
